import request from '../utils/request'

export default {
  // 获取所有
  findAll(params) {
    return request.get('/api/merchant', { params })
  },
  
  // 根据ID获取
  findById(id) {
    return request.get(`/api/merchant/${id}`)
  },
  
  // 添加子商户
  add(subMerchant) {
    return request.post('/api/merchant', subMerchant)
  },
  
  // 更新子商户
  update(id, subMerchant) {
    return request.put(`/api/merchant/${id}`, subMerchant)
  },

  // 启用/禁用
  status(id, status) {
    return request.put(`/api/merchant/status/${id}`, { status })
  },

  // 检查子商户ID是否存在
  checkSubMchIdUnique(params) {
    return request.get('/api/merchant/checkSubMchIdUnique', { params })
  },
}